<template>
  <TheTemplateM
    class="p-the-page-m15"
    :is-simple-header="true"
    :step="step"
    :step-options="stepOptions"
  >
    <template #heading>メールアドレス変更</template>

    <template #body>
      <div class="p-the-page-m15__message c-form-inner--wide">
        <p class="p-the-page-m15__message__text">
          {{ message }}
        </p>

        <div class="p-form-button-group">
          <div class="p-form-button-group__vertical">
            <ButtonMain :tag="'a'" href="/login/">ログインする</ButtonMain>
          </div>
        </div>
      </div>
    </template>
  </TheTemplateM>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

import TheTemplateM from "@/general/components/templates/TheTemplateM.vue";
import ButtonMain from "@/common/components/atoms/ButtonMain.vue";

import commons from "@/common/store/modules/commons";
import AuthStorage from "@/general/utils/auth";

@Options({
  props: {
    message: { type: String, required: true }
  },
  components: {
    TheTemplateM,
    ButtonMain
  }
})
export default class MyPageEmailSettingsError extends Vue {
  message!: string;

  step = 4;
  get stepOptions() {
    return [
      { step: 1, label: "入力" },
      { step: 2, label: "メール確認" },
      { step: 3, label: "本人認証" },
      { step: 4, label: "完了" }
    ];
  }

  breadcrumb = [
    {
      text: "",
      url: "/home",
      pageType: "home"
    },
    {
      text: "マイページ",
      url: "/my-page/",
      pageType: "lower"
    },
    {
      text: "メールアドレス変更",
      url: "",
      pageType: "lower"
    }
  ];

  mounted() {
    AuthStorage.checkLogin();
  }

  created() {
    commons.getBreadcrumb(this.breadcrumb);
  }
}
</script>

<style lang="scss" scoped>
.p-the-page-m15 {
  &__message {
    margin-top: rem(48);

    @include sp {
      margin-top: rem(36);
    }

    &__text {
      color: #4f4f4f;
      font-size: rem(20);
      font-weight: bold;
      line-height: (27/20);
      text-align: center;

      @include sp {
        font-size: rem(16);
      }

      & + & {
        margin-top: em(1.5);
      }
    }
  }
}
</style>
